import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/informationCircleInverted.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...n,
	children: [/* @__PURE__ */ t("g", {
		clipPath: "url(#clip0_25064_795)",
		children: [
			/* @__PURE__ */ e("path", {
				stroke: "#9ca2ab",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.25,
				d: "M11.875 13.75h-.625A1.25 1.25 0 0 1 10 12.5V9.375a.625.625 0 0 0-.625-.625H8.75"
			}),
			/* @__PURE__ */ e("path", {
				stroke: "#9ca2ab",
				strokeWidth: 1.25,
				d: "M9.688 6.25a.312.312 0 1 1 0-.625"
			}),
			/* @__PURE__ */ e("path", {
				stroke: "#9ca2ab",
				strokeWidth: 1.25,
				d: "M9.688 6.25a.312.312 0 1 0 0-.625"
			}),
			/* @__PURE__ */ e("path", {
				stroke: "#9ca2ab",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.25,
				d: "M10 19.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 0 0 0 18.75"
			})
		]
	}), /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", {
		id: "clip0_25064_795",
		children: /* @__PURE__ */ e("rect", {
			width: 20,
			height: 20,
			fill: "#fff"
		})
	}) })]
});
//#endregion
export { n as default };
